import React from "react"
import cx from "classnames"
import Link from "gatsby-link"

import { Chevron } from "../../identity"
import { GraphCms_Url } from "graphql-types"

type Props = {
  className?: string
  breadcrumb: Array<GraphCms_Url>
}

const Breadcrumb = ({ className, breadcrumb }: Props) => {
  return (
    <ul id="breadcrumb" className={cx(className)}>
      {breadcrumb.map((url: GraphCms_Url, index: number) => {
        return (
          <li key={url.id} className="inline-block mr-3">
            <Link to={url.pathname} className="text-xs mr-3 inline-block align-middle">
              {url.name}
            </Link>
            {breadcrumb.length !== index + 1 && (
              <span className="inline-block align-middle">
                <Chevron width={8} fill="#3E3E3E" />
              </span>
            )}
          </li>
        )
      })}
    </ul>
  )
}

export default Breadcrumb
